import React from 'react';
import SafeIcon from '../common/SafeIcon';
import supabaseService from '../services/supabaseService';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiDatabase, FiCheck, FiInfo } = FiIcons;

const AuthModal = ({ onClose, onAuthChange, isAuthenticated }) => {
  // Since we're using anon key, we'll show connection status instead
  const handleClose = () => {
    onClose();
  };

  const storageInfo = supabaseService.getStorageInfo();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-slate-200">
          <h2 className="text-xl font-semibold text-slate-900">
            Database Storage Info
          </h2>
          <button onClick={handleClose} className="p-2 hover:bg-slate-100 rounded-lg transition-colors">
            <SafeIcon icon={FiX} className="w-5 h-5 text-slate-500" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
              <SafeIcon icon={FiDatabase} className="w-5 h-5 text-green-600" />
            </div>
            <div>
              <h3 className="font-medium text-green-800">Connected to Supabase</h3>
              <p className="text-sm text-green-700">
                Your AI apps are automatically saved to the database
              </p>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <SafeIcon icon={FiInfo} className="w-5 h-5 text-blue-600 mt-0.5" />
              <div>
                <h4 className="font-medium text-blue-900 mb-1">Database Configuration</h4>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• Provider: {storageInfo.provider}</li>
                  <li>• Type: {storageInfo.type}</li>
                  <li>• Table: {storageInfo.tableName}</li>
                  <li>• Authentication: Using Supabase anon key</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <SafeIcon icon={FiCheck} className="w-5 h-5 text-slate-600 mt-0.5" />
              <div>
                <h4 className="font-medium text-slate-900 mb-1">Features Available</h4>
                <ul className="text-sm text-slate-700 space-y-1">
                  {storageInfo.features.map((feature, index) => (
                    <li key={index}>• {feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <button
            onClick={handleClose}
            className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;